<template>
  <Section id="packaging-section" class="packaging">
    <article class="packaging__cut packaging__black-cut">
      <div class="componata-container --is-narrow">
        <SectionHeader>
          <template v-slot:title>So wird Auspacken zum Erlebnis</template>
          <template v-slot:description>
            <p>Edle Geschenkboxen mattschwarz veredelt und mit handverlesenen Delikatessen befüllt<br>Präsente mit Wow-Effekt!</p>
          </template>
        </SectionHeader>

        <div class="packaging__spotlight">
          <img
            :srcset="`
              ${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=1900&nearlossless=1&compression=4 1900w,
              ${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4 950w
            `"
            sizes="
              (max-width: 36em) 100vw,
              59em
            "
            :src="`${require('@/assets/images/box-packaging-0@2x.png')}?format=${webPFormat('png')}&width=950&nearlossless=1&compression=4`"
            class="packaging__photo"
            alt="Componata's Verpackung"
            data-aos="fade-in"
            data-aos-duration="1400"
            loading="lazy"
          >
        </div>
      </div>
    </article>

    <article class="packaging__cut packaging__gray-cut">
      <div class="componata-container">
        <ul
          v-if="customFeatures && customFeatures.length > 0"
          class="packaging__features"
        >
          <li
            v-for="(feature, index) in customFeatures"
            :key="index"
            class="packaging__feature"
          >
            <span
              v-html="feature.icon"
              class="packaging__feature-svg"
            ></span>
            <h3 class="packaging__feature-title">{{ feature.title }}</h3>
            <p class="packaging__feature-description">{{ feature.description }}</p>
          </li>
        </ul>

        <ul
          v-else
          class="packaging__features"
        >
          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-handmade.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">In <b class="packaging__germany-text-mask">Deutschland</b> mit Liebe von Hand verpackt</h3>
            <p class="packaging__feature-description">Jade Präsentbox wird nach Ihren Wünschen und Anforderungen von Hand verpackt.</p>
          </li>

          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-box.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">Atemberaubende mattschwarze Box mit Magnetverschluss</h3>
<p class="packaging__feature-description">Edle Geschenkboxen mattschwarz veredelt und mit handverlesenen Delikatessen befüllt — Präsente mit Wow-Effekt!</p>
          </li>

          <li class="packaging__feature">
            <img src="@/assets/images/landing-page/icon-truck.svg" class="packaging__feature-icon">
            <h3 class="packaging__feature-title">Direktversand an Beschenkte</h3>
<p class="packaging__feature-description">Unsere Präsente sind stets geschenkfertig. Unabhängig von der Stückzahl ist ein direkter, Geschäftspartner und Kunden möglich.</p>
          </li>
        </ul>
      </div>
    </article>
  </Section>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';

export default {
  name: 'Packaging',
  mixins: [logicMixin, helperMixin],
  props: {
    customFeatures: {
      type: Array,
      default: null
    }
  },
  components: {
    Section,
    SectionHeader
  },
  methods: {
    getImg: function() {
      try {
        return require(`@/assets/images/box-packaging-0@2x.png?format=${this.webPFormat('png')}&width=950&nearlossless=1&compression=4`);
      } catch (ex) {
        return '';
      }
    },
  }
};
</script>

<style lang="scss" scoped>
/**
 * Packaging
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present packaging features
 * @since 2020-10-28
**/

$component: 'packaging';

.#{$component} {
  color: #d4d8de;

  &__black-cut {
    background: radial-gradient(#1b1b1b, #0C0C0C 30%);

    > .lp-container {
      position: relative;
    }
  }

  &__cut {
    @include margin-top(- map-get($spacers, 4) * 4);
    @include margin-bottom(- map-get($spacers, 4) * 4);
    @include padding-top(map-get($spacers, 4) * 4);
    @include padding-bottom(map-get($spacers, 4) * 4);
  }

  &__gray-cut {
    @include padding-top(map-get($spacers, 4) * 3 !important);
    background: #1C1C1C;
  }

  // Spotlight
  &__spotlight {
    display: flex;
    justify-content: center;
    overflow: hidden;
    @include padding-top(map-get($spacers, 4));
  }

  &__photo {
    max-width: 100%;
    @include margin-top(- map-get($spacers, 6) * 3);
    @include margin-bottom(- map-get($spacers, 6) * 5);
    @include imageRendering;
    // margin-left: -5%;
  }

  // Offer
  &__offer {
    position: absolute;
    @include rfs(map-get($spacers, 7), bottom);
    @include rfs(map-get($spacers, 3), right);
  }

  &__cta {
    display: flex;
    @include margin-top(map-get($spacers, 4));
  }

  // Features
  &__features {
    @include unlist;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__feature {
    flex: 0 0 28%;
  }

  &__feature-icon {
    width: 64px;
    height: auto;
  }

  &__feature-svg {
    display: inline-block;
    width: 64px;
    height: auto;
    color: #d4d8de;

    svg {
      color: #d4d8de;
    }

    path {
      color: #d4d8de;
    }
  }

  &__feature-title {
    @include margin-top(map-get($spacers, 4));
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($landing-page, 'font-size-lg'));
    line-height: 130%;
  }

  &__feature-description {
    margin: 0;
    font-weight: $font-weight-lighter;
  }

  &__germany-text-mask {
    font-weight: $font-weight-bolder;
    // text-shadow: 1px 1px 4px lighten(#1C1C1C, 10%);
    background: linear-gradient(to right, #616161, #9a4756, #b7ac83);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__offer {
      @include rfs(map-get($spacers, 6), right);
      @include rfs(map-get($spacers, 7), bottom);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__offer {
      ::v-deep .price,
      ::v-deep .quantity-selector {
        display: none;
      }
    }

    &__features {
      @include margin-bottom(- map-get($spacers, 4) * 3)
    }

    &__feature {
      flex: 0 0 48%;
      @include margin-bottom(map-get($spacers, 4) * 3);
    }

    &__feature-title {
      width: 70%;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__feature {
      flex: 0 0 100%;
      @include margin-bottom(map-get($spacers, 4) * 4);
    }
  }
}
</style>
